declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_bidi_indexed_foo extends $mol_object {
		owner( id: any, next?: any ): any
		indexed( id: any, next?: ReturnType< $mol_view_tree2_to_js_test_ex_bidi_indexed_foo['owner'] > ): ReturnType< $mol_view_tree2_to_js_test_ex_bidi_indexed_foo['owner'] >
	}
	
}

//# sourceMappingURL=bidi_indexed.view.tree.d.ts.map